import TruncateList from './truncate-list';

export { getTextWidth } from './truncate-list';
export default TruncateList;
